import ButtonLink from 'components/shared/ButtonLink.styled';
import { Heading2 } from 'components/shared/Typography';
import Link from 'next/link';
import Slide from 'react-reveal/Slide';
import { getPublicPath } from 'utils/paths';
import {
  StyledFeature,
  StyledFeatureAction,
  StyledFeatureContent,
  StyledFeatureImage,
  StyledFeatureTelegramTitle
} from './Feature.styled';

type FeatureProps = {
  title: string;
  text: React.ReactNode;
  image: string;
  action?: string;
  actionHref?: string;
  btnVariant?: string;
  actionIcon?: React.ReactNode;
  reverse?: boolean;
  telegram?: string;
  innerLink?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
};

const Feature: React.FC<FeatureProps> = ({
  title,
  text,
  image,
  action,
  actionHref,
  btnVariant = 'primary',
  actionIcon,
  reverse = false,
  telegram,
  innerLink = false,
  children,
  onClick = () => {
    // NOOP
  }
}) => {
  return (
    <StyledFeature reverse={reverse}>
      <Slide
        left={!reverse ? true : undefined}
        right={reverse ? true : undefined}
      >
        <StyledFeatureImage>
          <img src={getPublicPath('/images/web/' + image)} alt="" />
        </StyledFeatureImage>
      </Slide>

      <StyledFeatureContent>
        <Slide
          left={reverse ? true : undefined}
          right={!reverse ? true : undefined}
        >
          <>
            {telegram && (
              <StyledFeatureTelegramTitle>
                {telegram}
              </StyledFeatureTelegramTitle>
            )}
            <Heading2>{title}</Heading2>
            {text && typeof text === 'object' && text}
            {typeof text === 'string' && (
              <p dangerouslySetInnerHTML={{ __html: text || '' }}></p>
            )}
            {action && (
              <StyledFeatureAction>
                {innerLink && (
                  <Link href={actionHref || '#'} passHref>
                    <ButtonLink
                      variant={btnVariant}
                      sizes="md"
                      onClick={onClick}
                    >
                      {actionIcon}
                      <span>{action}</span>
                    </ButtonLink>
                  </Link>
                )}

                {!innerLink && (
                  <ButtonLink
                    href={actionHref || '#'}
                    variant={btnVariant}
                    sizes="md"
                    onClick={onClick}
                  >
                    {actionIcon}
                    <span>{action}</span>
                  </ButtonLink>
                )}
              </StyledFeatureAction>
            )}
            {children}
          </>
        </Slide>
      </StyledFeatureContent>
    </StyledFeature>
  );
};

export default Feature;
